export const selectSnackbar = (state: IState) => state.snackbar
